exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle[data-v-937971d2] {\n  width: 110px;\n  height: 110px;\n  border-radius: 100%;\n}\n.line_nps .box_smile[data-v-937971d2] {\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n  height: 30px;\n  font-size: 20px;\n}", ""]);

// exports
